module.exports = __webpack_public_path__ + "static/media/grubhero-screenshot-2.340ea0e9.png";